import { createRouter, createWebHistory } from 'vue-router';
import TeaserPage from '../components/TeaserPage.vue';
import PaymentPage from '../components/PaymentPage.vue';
import AccessPage from '../components/AccessPage.vue';

const routes = [
  {
    path: '/',
    name: 'Teaser',
    component: TeaserPage,
  },
  {
    path: '/payment',
    name: 'Payment',
    component: PaymentPage,
  },
  {
    path: '/access',
    name: 'Access',
    component: AccessPage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
